import React, { Component } from "react";
import Moment from "moment";
import ATable from "../common/table";
import Constants from "../../configurations/constants";
import Modal from "../common/modal";
import RenderObjects from "../common/ObjectRenderer";

class ReportsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedRow: null,
      ellipses: ""
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.interval = [];
    this.ellipsesInterval = setInterval(this.updateEllipses, 500);
    if (this.props.reports && this.props.reports.length) {
      this.props.reports.forEach(
        (report, index) =>
          (this.interval[index] = setInterval(
            () => this.props.getReportStatus(report),
            5000
          ))
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reports.length && nextProps.reports.length > this.props.reports.length) {
      const nextReport = nextProps.reports[nextProps.reports.length - 1];
      this.interval[nextProps.reports.length - 1] = setInterval(
        () => this.props.getReportStatus(nextReport),
        5000
      );
    }
    nextProps.reports.forEach((report, index) => {
      if (
        report.status.toLowerCase() ===
        Constants.SETTLEMENT_REPORT_STATUS.COMPLETED ||
        report.status.toLowerCase() ===
        Constants.SETTLEMENT_REPORT_STATUS.FAILED
      ) {
        clearInterval(this.interval[index]);
      }
    });
  }

  componentWillUnmount() {
    this.interval.forEach(interval => clearInterval(interval));
    clearInterval(this.ellipsesInterval);
  }

  updateEllipses = () => {
    this.setState(prevState => {
      const newEllipses = prevState.ellipses.length >= 3 ? "" : prevState.ellipses + ".";
      return { ellipses: newEllipses };
    });
  };

  showModal(data) {
    this.setState({
      showModal: true,
      selectedRow: data
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      selectedRow: null
    });
  }

  render() {
    const modalStyle = {
      overlay: {},
      content: {
        top: "80px",
        left: "250px",
        right: "250px",
        bottom: "180px",
        zIndex: "1000"
      }
    };

    const columns = [
      {
        header: "S/N",
        width: 50,
        render: row => <div>{this.props.paginatedCallback(row.viewIndex)}</div>
      },
      {
        header: "Search Criteria",
        render: row => {
          let searchCriteria;
          if (row.row.reportParams) {
            const reportObject = JSON.parse(row.row.reportParams);
            const { pageNum, pageSize, ...reportParams } = reportObject;
            searchCriteria = (
              <div onClick={() => this.showModal(reportParams)}>
                <a className="">View Criteria</a>
              </div>
            );
          }
          return searchCriteria;
        },
        width: 250
      },
      {
        header: "File Type",
        render: row => {
          let reportType;
          if (row.row.reportType) {
            reportType = row.row.reportType;
          } else if (row.row.reportParams) {
            const reportParamsObject = JSON.parse(row.row.reportParams);
            reportType = reportParamsObject.reportType;
          }
          return reportType;
        },
        width: 90
      },
      {
        header: "Status",
        accessor: "status",
        render: row => {
          return row.row.status;
        },
        width: 90
      },
      {
        header: "File name",
        accessor: "fileName",
        render: row => {
          return row.row.fileName
            ? row.row.fileName
            : "-- Report not available --";
        }
      },
      {
        header: "Created By",
        accessor: "createdBy",
        render: row => {
          return row.row.createdBy;
        }
      },
      {
        header: "Created On",
        accessor: "createdOn",
        render: row => {
          return Moment(row.row.createdOn).format(Constants.DATE_FORMAT_LONG);
        }
      },
      {
        header: "",
        accessor: "action",
        render: row => {
          const status = row.row.status.toLowerCase();
          const dateDifference = Moment().diff(Moment(row.row.createdOn));
          const isValidPending = dateDifference < Constants.SETTLEMENT_REPORT_MAXTIME;

          return (
            <div>
              {status === Constants.SETTLEMENT_REPORT_STATUS.COMPLETED ? (
                <button
                  className="btn-link"
                  onClick={() => {
                    this.props.downloadReports(row.row.fileName);
                  }}
                >
                  Download
                </button>
              ) : status === Constants.SETTLEMENT_REPORT_STATUS.FAILED ? (
                <button
                  className="btn-link"
                  onClick={() => {
                    this.props.retryReportGeneration(row.row.id);
                  }}
                >
                  Retry
                </button>
              ) : (status === Constants.SETTLEMENT_REPORT_STATUS.PENDING ||
                  status === Constants.SETTLEMENT_REPORT_STATUS.PROCESSING) &&
                isValidPending ? (
                <span className="text-info">
                  Generating Report{this.state.ellipses}
                </span>
              ) : (
                <span className="text-info" style={{ marginLeft: "9px" }}>
                No Data
              </span>
              )}
            </div>
          );
        }
      }
    ];

    return (
      <div>
        <ATable
          className="-striped -highlight"
          tableData={this.props.reports}
          noDataText={
            this.props.reportType
              ? `No ${this.props.reportType} reports found`
              : "Select a report type"
          }
          columns={columns}
          onChange={this.props.onTableChange || null}
          manual
          {...this.props}
        />
        <Modal
          title="Report parameters"
          isOpen={this.state.showModal}
          onRequestClose={this.closeModal}
          style={modalStyle}
        >
          <RenderObjects
            className="dispute-col"
            objectToConv={this.state.selectedRow}
          />
        </Modal>
      </div>
    );
  }
}

export default ReportsTable;



// WEBPACK FOOTER //
// ./src/components/reports/ReportsTable.js